/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

interface Props {
	label: string;
	value?: string;
}

const PAMediaInfoCard: React.FC<Props> = ({ label, value="" }) => {
	return (
		<div className="space-y-2">
			<label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
				{label}
			</label>
			<input
				type="text"
				readOnly
				value={value}
				className="w-full px-4 py-2 bg-slate-50 border border-slate-100 rounded-lg text-[12px] font-bold text-slate-500 outline-none"
			/>
		</div>
	);
};

export default PAMediaInfoCard;
